var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container pl-10 pr-10 pt-10" },
    [
      _c(
        "div",
        { staticClass: "row pl-3 pr-3" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED089",
                  expression: "'ED089'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Dar permisos",
                  expression: "'Dar permisos'"
                }
              ],
              staticClass: "mr-3 btn-icon",
              class: {
                "cursor-not-allowed": _vm.userPermissions.totalControl === 0
              },
              attrs: {
                disabled: _vm.userPermissions.totalControl === 0,
                variant: "primary",
                "data-cy": "give-permission"
              },
              on: { click: _vm.newPermission }
            },
            [_c("feather-icon", { attrs: { icon: "ShieldIcon" } })],
            1
          )
        ],
        1
      ),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ],
          staticClass: "table b-table mt-5 mb-0"
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Lectura")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Escritura")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Control Total")]),
              _vm.getSelectedElement.type === "folder"
                ? _c("th", { attrs: { scope: "col" } }, [
                    _vm._v("Hereda permisos")
                  ])
                : _vm._e(),
              _c("th", { attrs: { scope: "col" } })
            ])
          ]),
          _c(
            "tbody",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading === false,
                  expression: "loading === false"
                }
              ]
            },
            _vm._l(_vm.permissionsList, function(permission, index) {
              return _c(
                "tr",
                {
                  key: "permission_" + index,
                  attrs: { "data-cy": "permission-line" }
                },
                [
                  _c(
                    "td",
                    [
                      _c("b-avatar", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: permission.nombreEntidad,
                            expression: "permission.nombreEntidad"
                          }
                        ],
                        staticClass: "mr-3",
                        attrs: {
                          icon:
                            permission.tipoEntidad === "G" ? "people-fill" : "",
                          src: permission.avatar,
                          variant: "secondary"
                        }
                      }),
                      _vm._v(" " + _vm._s(permission.nombreEntidad) + " ")
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("b-form-checkbox", {
                        attrs: {
                          value: "1",
                          "unchecked-value": "0",
                          disabled: ""
                        },
                        model: {
                          value: permission.lectura,
                          callback: function($$v) {
                            _vm.$set(permission, "lectura", $$v)
                          },
                          expression: "permission.lectura"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("b-form-checkbox", {
                        attrs: {
                          value: "1",
                          "unchecked-value": "0",
                          disabled: ""
                        },
                        model: {
                          value: permission.escritura,
                          callback: function($$v) {
                            _vm.$set(permission, "escritura", $$v)
                          },
                          expression: "permission.escritura"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("b-form-checkbox", {
                        attrs: {
                          value: "1",
                          "unchecked-value": "0",
                          disabled: ""
                        },
                        model: {
                          value: permission.controlTotal,
                          callback: function($$v) {
                            _vm.$set(permission, "controlTotal", $$v)
                          },
                          expression: "permission.controlTotal"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.getSelectedElement.type === "folder"
                    ? _c(
                        "td",
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              value: "1",
                              "unchecked-value": "0",
                              disabled: ""
                            },
                            model: {
                              value: permission.todoPermisos === "Y" ? 1 : 0,
                              callback: function($$v) {
                                _vm.$set(
                                  permission,
                                  "todoPermisos === 'Y' ? 1 : 0",
                                  $$v
                                )
                              },
                              expression:
                                "permission.todoPermisos === 'Y' ? 1 : 0"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "td",
                    [
                      _c(
                        "b-button-group",
                        [
                          (permission.idEntidad !== _vm.currentUser.id &&
                            _vm.userPermissions.totalControl === 1) ||
                          (_vm.getSelectedElement.ownerId !==
                            _vm.currentUser.id &&
                            _vm.userPermissions.totalControl === 1)
                            ? _c(
                                "b-dropdown",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(113, 102, 240, 0.15)",
                                      expression: "'rgba(113, 102, 240, 0.15)'",
                                      modifiers: { "400": true }
                                    }
                                  ],
                                  attrs: {
                                    text: "Acciones",
                                    "data-cy": "actions",
                                    variant: "outline-primary",
                                    size: "sm"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "has-permission",
                                          rawName: "v-has-permission",
                                          value: "ED090",
                                          expression: "'ED090'"
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.editPermission(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "text-success",
                                        attrs: { icon: "EditIcon" }
                                      }),
                                      _vm._v(" Editar ")
                                    ],
                                    1
                                  ),
                                  permission.idEntidad !== _vm.currentUser.id
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          directives: [
                                            {
                                              name: "has-permission",
                                              rawName: "v-has-permission",
                                              value: "ED091",
                                              expression: "'ED091'"
                                            }
                                          ],
                                          on: {
                                            click: function($event) {
                                              return _vm.deletePermission(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "text-danger",
                                            attrs: { icon: "Trash2Icon" }
                                          }),
                                          _vm._v(" Eliminar ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "tbody",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading === true,
                  expression: "loading === true"
                }
              ]
            },
            [
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("b-skeleton", {
                      attrs: { animation: "fade", type: "avatar" }
                    })
                  ],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c("td", { staticClass: "pt-10" })
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("b-skeleton", {
                      attrs: { animation: "fade", type: "avatar" }
                    })
                  ],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "pt-10" },
                  [_c("b-skeleton", { attrs: { animation: "fade" } })],
                  1
                ),
                _c("td", { staticClass: "pt-10" })
              ])
            ]
          )
        ]
      ),
      _vm.modalName
        ? _c("EDPermissionsForm", {
            attrs: {
              selectedPermission: _vm.selectedPermission,
              element: _vm.getSelectedElement,
              list: _vm.permissionsList,
              loadPermissions: _vm.loadPermissions
            },
            on: { "update-permissions": _vm.setPermissions }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }